// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VScCuO-8ngEFOI0DYHN7w"};